//****************************************************************************//
//                         DELIVERY OPTION SERVICE                           //
//****************************************************************************//

/*ALL THE NETWORK CALLS MADE TO RETRIEVE STORE INFORMATION SHOULD GO HERE*/

import { NETWORK_URLS } from '../constants/NetworkConstants';
import { apiUrl, headerHelper } from '../helper/Utility'

export default class StoreService {
  static getAllStores = async (token) => {
    var endpoint = NETWORK_URLS.get_all_stores;
    var encodedUrl = apiUrl() + endpoint;
    try {
      var response = await fetch(encodedUrl,{method: 'GET', headers: headerHelper(token)});
      var responseJson = await response.json();
      return responseJson;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  static getStoreCredentials = async (token,store_id) => {
    var endpoint = NETWORK_URLS.get_store_credentials.replace('store_id',store_id);
    var encodedUrl = apiUrl() + endpoint;
    try {
      var response = await fetch(encodedUrl,{method: 'GET', headers: headerHelper(token)});
      var responseJson = await response.json();
      return responseJson;
    } catch (e) {
      console.log(e);
      return e;
    }
  }
}